/**
 * Body of the consumer Terms of Service document, shared between the
 * standalone /terms page (Consumer tab) and the in-settings Legal modal.
 */
export const TermsConsumerContent = () => (
	<>
		<h1>Terms and Conditions for Solar Marketplace</h1> <br />
		<p>Effective Date: 29th July, 2024 </p> <br />
		<h2>1. Introduction</h2>
		<p>
			{" "}
			Welcome to Yansa Analytics Ltd. These Terms and Conditions ("Terms") govern your use of our solar marketplace and financing services ("Services").
			By applying for or using our Services, you agree to be bound by these Terms.
		</p>{" "}
		<h2>2. Definitions</h2>
		<strong>- Customer:</strong> The individual or entity applying for or using the Services.
		<br />
		<strong>- Company:</strong> Yansa Analytics Ltd, including its affiliates and subsidiaries.
		<br />
		<strong>- Agreement:</strong> The agreement between the Customer and the Company, incorporating these Terms.
		<br />
		<strong>- Loan:</strong> The amount financed by the Company for the purchase and installation of solar equipment.
		<br />
		<strong>- Repayment Schedule:</strong> The schedule outlining the Customer's repayment obligations.
		<br />
		<h2>3. Eligibility</h2> To be eligible for our Services, you must: <br />- Be at least 18 years old.
		<br /> - Provide accurate and complete information during the application process.
		<br /> - Own the property where the solar equipment will be installed or have written consent from the property owner.
		<h2>4. Application and Approval</h2> - The Customer must complete and submit an application form.
		<br />
		- The Customer must grant the company access to access their Credit history and read access to their Income/Bank Account Statement
		<br /> - The Company reserves the right to approve or reject any application at its sole discretion.
		<br /> - Approval is subject to creditworthiness and other criteria established by the Company.
		<h2>5. Loan Terms</h2> <strong>- Repayment Term:</strong> The duration over which the Device amount must be repaid, typically measured in months or
		years.
		<br /> <strong>- Monthly Payment:</strong> The amount due each month.
		<h2>6. Repayment</h2> - Payments must be made according to the Repayment Schedule provided by the Company.
		<br /> - Payments can be made via [accepted payment methods].
		<br /> - Late payments may incur additional fees and interest as specified in the Agreement.
		<br /> - Yansa Analytics reserves the right to Debit cards and bank accounts connected if the customer defaults on repayment
		<br /> - Yansa Analytics reserves the right to report customers who default on repayment to the Credit bureau.
		<h2>7. Prepayment</h2> - The Customer may prepay the Total Amount in full or in part at any time without penalty.
		<h2>8. Default</h2> The Customer will be in default if:
		<br /> - A payment is not made when due.
		<br /> - The Customer breaches any term of this Agreement.
		<br /> - The Customer becomes insolvent or bankrupt. <br /> <br />
		Upon default, the Company may:
		<br /> - Demand immediate payment of the entire outstanding amount.
		<br /> - Charge additional fees and interest.
		<br /> - Take legal action to recover the amount owed.
		<br /> - Retrieve device without refunding initial amount paid <h2>9. Security Interest</h2> - The Company may require a security interest in the
		solar equipment as collateral for the Loan.
		<br /> - The Customer agrees to grant the Company a security interest in the equipment during the repayment process.{" "}
		<h2>10. Installation and Maintenance</h2> - The Company is responsible for the installation of the solar equipment.
		<br /> - The Customer is responsible for the maintenance of the solar Equipment.
		<br /> - The Company will assign a designated solar provider for the installation of the Solar Equipment and bear the cost for the installation..{" "}
		<h2>11. Warranty and Liability</h2> - The Company does not provide any warranties for the solar equipment or installation services.
		<br /> - The Customer should refer to the manufacturer’s warranty for the equipment.
		<br /> - The Company is not liable for any damages arising from the installation or use of the solar equipment. <h2>12. Privacy</h2> - The Company
		will collect and use the Customer’s personal information in accordance with its Privacy Policy.
		<br /> - The Customer consents to the collection, use, and disclosure of their personal information as described in the Privacy Policy.{" "}
		<h2>13. Governing Law</h2> These Terms and the Agreement will be governed by and construed in accordance with the laws of Nigeria.{" "}
		<h2>14. Dispute Resolution</h2> - Any disputes arising out of or related to these Terms or the Agreement will be resolved through
		arbitration/mediation in Nigeria.
		<br /> - The Customer and the Company agree to waive the right to a trial by jury.
		<h2>15. Amendments</h2> The Company reserves the right to amend these Terms at any time. The Customer will be notified of any material changes, and
		continued use of the Services constitutes acceptance of the amended Terms. <h2>16. Contact Information</h2> For any questions or concerns regarding
		these Terms or the Services, please contact us at: <br />
		<br /> Yansa Analytics Limited
		<br /> 12a Talabi Street, Ikeja, Lagos
		<br /> info@yansaafrica.com
		<br /> <br /> --- <br /> <br /> By applying for and using our Services, you acknowledge that you have read, understood, and agree to be bound by
		these Terms and Conditions. <br />
		<br />
		---
	</>
);

export default TermsConsumerContent;
